import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showLeftSidebar: true,
  showRightSidebar: true,
  showBottomPanel: true,
  leftSidebar: true,
  rightSidebar: true,
  bottomPanel: true
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleLeftSidebar: (state) => {
      state.showLeftSidebar = !state.showLeftSidebar;
      state.leftSidebar = state.showLeftSidebar;
    },
    toggleRightSidebar: (state) => {
      state.showRightSidebar = !state.showRightSidebar;
      state.rightSidebar = state.showRightSidebar;
    },
    toggleBottomPanel: (state) => {
      state.showBottomPanel = !state.showBottomPanel;
      state.bottomPanel = state.showBottomPanel;
    },
    setSidebarsVisibility: (state, action) => {
      const payload = action.payload;
      
      if (payload) {
        Object.entries(payload).forEach(([key, value]) => {
          if (typeof value === 'boolean') {
            state[key] = value;
          }
        });
        
        // Keep naming conventions in sync
        if (payload.showLeftSidebar !== undefined) state.leftSidebar = payload.showLeftSidebar;
        if (payload.showRightSidebar !== undefined) state.rightSidebar = payload.showRightSidebar;
        if (payload.showBottomPanel !== undefined) state.bottomPanel = payload.showBottomPanel;
        
        if (payload.leftSidebar !== undefined) state.showLeftSidebar = payload.leftSidebar;
        if (payload.rightSidebar !== undefined) state.showRightSidebar = payload.rightSidebar;
        if (payload.bottomPanel !== undefined) state.showBottomPanel = payload.bottomPanel;
      }
    }
  },
});

export const { 
  toggleLeftSidebar, 
  toggleRightSidebar, 
  toggleBottomPanel,
  setSidebarsVisibility
} = uiSlice.actions;

export default uiSlice.reducer;